import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import Ben_Ver_Abstract_Office from './Ben_Ver_Abstract_Office';


const version_abs = async () => {

  const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/beneficiary/distcount`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',


    },
  });

  const data_variable = await response.json()
  if (data_variable.rep_code == "200") {

    return data_variable;
  }
  return data_variable;
};

const Ben_Ver_Abstract = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const fpstab = useRef(null); // Use ref to scroll to this div
  const navigate = useNavigate();
  const [renderContentt, setRenderContentt] = useState(null);
  const detailsRRef = useRef(null);
  const [userRole, setUserRole] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleDistClick = (dist_code) => {

    setRenderContentt(
      <Ben_Ver_Abstract_Office dist_code={dist_code} />
    );
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/ekyc-to-be-done/session-info`, { withCredentials: true })
      .then(res => {
        setUserRole(res.data.userRole);
      })
      .catch(() => {

        setSessionExpired(true);
        //setUserRole("1"); 
      });

  }, []);


  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await version_abs();
        setTabHeading(response_data.heading);

        if (response_data.data.length > 0) {
          setReportData(response_data.data);
        } else {
          setReportData([]);
        }

      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
      detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box></div>
  }
  if (error) {
    return <div class="mainhead" align="center">
      Internal Error
    </div>
  }
  if (reportData.length === 0) {
    return <div class="mainhead" align="center">
      No data found
    </div>
  }

  const handleExcelDownload = async (status, dist_code) => {
    try {
      const response1 = await axios.get(
        `${process.env.REACT_APP_URL}/api/beneficiary/excelDownload`,
        {
          params: { status, dist_code },
          responseType: "blob",
          withCredentials: true
        }
      );

      const blob = new Blob([response1.data], {
        type: "application/vnd.ms-excel",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const disposition = response1.headers["content-disposition"];
      let filename = "Beneficiary_Report.xls";

      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      alert("Download failed");
    }
  };


  const totals = reportData.reduce(
    (acc, item) => {
      acc.today_total_app += item.today_ekyc || 0;
      acc.today_app_today += item.app_today || 0;

      acc.month_month_ekyc += item.month_ekyc || 0;
      acc.month_app_month += item.app_month || 0;

      acc.total_total_ekyc += item.total_ekyc || 0;
      acc.total_total_app += item.total_app || 0;

      return acc;
    },
    {
      today_total_app: 0,
      today_app_today: 0,

      month_month_ekyc: 0,
      month_app_month: 0,

      total_total_ekyc: 0,
      total_total_app: 0,
    }
  );

  return (
    <>
      <br /><br />

      <table ref={fpstab} align="center" width="50%" border={1}>
        <thead>
          <th className="tableheader" colSpan={8}>Beneficiary Verification Abstract</th>
          <tr className="tableheader">
            <th rowspan="3">Sl.No</th>
            <th rowspan="3">District</th>
            <th colspan="4">Performed</th>
            <th rowspan="2" colspan="2" >Total</th>
          </tr>
          <tr class="tableheader">
            <th colspan="2" >Today</th>
            <th colspan="2" >current month</th>
          </tr>

          <tr class="tableheader">
            <th>key Register</th>
            <th>New App</th>
            <th>key Register</th>
            <th>New App</th>
            <th>key Register</th>
            <th>New App</th>
          </tr>
        </thead>

        {/* {userRole === '0' || userRole === null || userRole === '' ? ( */}

        <tbody>
          {reportData.map((item, index) => {

            return (
              <tr key={item.dist_code}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>

                <td align="left">
                  <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleDistClick(item.dist_code)}>
                    {item.dist_name_en}
                  </a>
                </td>
                <td style={{ textAlign: 'right' }}>  {item.today_ekyc ?? 0}</td>
                <td style={{ textAlign: 'right' }}>{item.app_today ?? 0}</td>
                <td style={{ textAlign: 'right' }}>{item.month_ekyc ?? 0}</td>
                <td style={{ textAlign: 'right' }}>{item.app_month ?? 0}</td>
                <td style={{ textAlign: 'right' }}>{item.total_ekyc ?? 0}</td>
                <td style={{ textAlign: 'right' }}>{item.total_app ?? 0}</td>
              </tr>
            );
          })}
          <tr class="tableheader">

            <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_total_app ?? 0}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_app_today ?? 0}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_month_ekyc ?? 0}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_app_month ?? 0}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_ekyc ?? 0}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_app ?? 0}</td>
          </tr>
        </tbody>
        {/* ) : (

          <tbody>
            {reportData.map((item, index) => {

              return (
                <tr key={item.dist_code}>
                  <td style={{ textAlign: 'center' }}>{index + 1}</td>

                  <td align="left">
                    <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleDistClick(item.dist_code)}>
                      {item.dist_name_en}
                    </a>
                  </td>

                  <td align="right">
                    {item.today_ekyc_keyreg > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(1, item.dist_code)}
                      >
                        {item.today_ekyc_keyreg}
                      </span>
                    ) : item.today_ekyc_keyreg}
                  </td>
                  <td align="right">
                    {item.today_ekyc_newapp > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(2, item.dist_code)}
                      >
                        {item.today_ekyc_newapp}
                      </span>
                    ) : totals.today_ekyc_newapp}
                  </td>
                  <td align="right">
                    {item.month_ekyc_keyreg > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(3, item.dist_code)}
                      >
                        {item.month_ekyc_keyreg}
                      </span>
                    ) : item.month_ekyc_keyreg}
                  </td>

                  <td align="right">
                    {item.month_ekyc_newapp > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(4, item.dist_code)}
                      >
                        {item.month_ekyc_newapp}
                      </span>
                    ) : item.month_ekyc_newapp}
                  </td>

                  <td align="right">
                    {item.total_keyreg > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(5, item.dist_code)}
                      >
                        {item.total_keyreg}
                      </span>
                    ) : item.total_keyreg}
                  </td>

                  <td align="right">
                    {item.total_newapp > 0 ? (
                      <span
                        style={{ color: "orange", textDecoration: "underline", fontWeight: "bold", cursor: "pointer" }}
                        onClick={() => handleExcelDownload(6, item.dist_code)}
                      >
                        {item.total_newapp}
                      </span>
                    ) : item.total_newapp}
                  </td>

                </tr>
              );
            })}
            <tr class="tableheader">

              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.today_ekyc_keyreg > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('today_ekyc_keyreg')}
                  >
                    {totals.today_ekyc_keyreg}
                  </span>
                ) : totals.today_ekyc_keyreg}
              </td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.today_ekyc_newapp > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('today_ekyc_newapp')}
                  >
                    {totals.today_ekyc_newapp}
                  </span>
                ) : totals.today_ekyc_newapp}
              </td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.month_ekyc_keyreg > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('month_ekyc_keyreg')}
                  >
                    {totals.month_ekyc_keyreg}
                  </span>
                ) : totals.month_ekyc_keyreg}
              </td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.month_ekyc_newapp > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('month_ekyc_newapp')}
                  >
                    {totals.month_ekyc_newapp}
                  </span>
                ) : totals.month_ekyc_newapp}
              </td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.total_keyreg > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('total_keyreg')}
                  >
                    {totals.total_keyreg}
                  </span>
                ) : totals.total_keyreg}
              </td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                {totals.total_newapp > 0 ? (
                  <span
                    style={{ color: "orange", textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => handleExcelDownload('total_newapp')}
                  >
                    {totals.total_newapp}
                  </span>
                ) : totals.total_newapp}
              </td>
            </tr>
            
          </tbody>

        )}
*/}
      </table>
      <br /><br />

      <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
    </>
  );
};

export default Ben_Ver_Abstract;
